import { createSlice } from "@reduxjs/toolkit";
import { getHeroSection, updateHeroSection } from "actions/heroSections";

const initialState = {
  loading: false,
  heroSection: null,
  updateLoading: false,
  error: null,
};

export const heroSectionsSlice = createSlice({
  name: "heroSections",
  initialState,
  reducers: {
    clearHeroSection: (state) => {
      state.heroSection = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getHeroSection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHeroSection.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.heroSection = payload;
      })
      .addCase(getHeroSection.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(updateHeroSection.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateHeroSection.fulfilled, (state, { payload }) => {
        state.updateLoading = false;
        state.heroSection = payload;
      })
      .addCase(updateHeroSection.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });
  },
});

export const { clearHeroSection } = heroSectionsSlice.actions;

export default heroSectionsSlice.reducer;
